import { z } from 'zod/v4';

export const ShareAssetParamsSchema = z.object({
  assetId: z.string().min(1).max(64),
});

export type ShareAssetParams = z.infer<typeof ShareAssetParamsSchema>;

export const ShareAssetBodySchema = z.object({
  companyId: z.string().min(1).max(64),
});

export type ShareAssetBody = z.infer<typeof ShareAssetBodySchema>;
